import React, { useEffect } from "react";
import "./Logo_modal.css";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Logo_modal({ successText, onHide, show, ...props }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        if (onHide) onHide(); // close modal
        navigate("/luxury/home"); // redirect
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [show, onHide, navigate]);

  return (
    <>
      <Modal
        {...props}
        show={show}
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Logo_modal"
      >
        <Modal.Body>
          <div className="img_holder">
            <img
              src="/assest/image/logo/header-logo.png"
              alt="logo"
              className="logo_img"
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Logo_modal;
